// The triple-slash directive below is a TypeScript reference directive required to include type definitions from the @angular/localize package.
// This ensures that TypeScript is aware of the localization types used throughout this Angular application.
/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    // Remove the index.html spinner element from the DOM after the app has been initialized
    document.getElementById('index-spinner')?.remove();
  })
  .catch((err) => {
    console.error('Error during app initialization:', err);
  });
